import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppConfigService } from './app-config.service';
import { RebarAuthService } from '../rebarauth/rebar.auth.service';
import {
  ApplicationLogFieldResponse,
  ApplicationLogResponse,
  AuditLogFilterOption,
  AuditLogRequestParams,
} from '../../admin/audit-log/audit-log.interfaces';

@Injectable({
  providedIn: 'root',
})
export class MasterService {
  private get baseUrl(): string {
    return this.appConfigService.config['MasterFunctionUrl'] as string || '';
  }

  constructor(private http: HttpClient, public authService: RebarAuthService, private appConfigService: AppConfigService) {}

  getUserTabAccess(enterpriseId: string): Observable<any> {
    const postData = {
      params: {
        category: 'GetUserTabAccess',
        EnterpriseID: enterpriseId
      }
    };
    return this.http.post(this.baseUrl, postData);
  }

  getUserProfile(enterpriseId: string): Observable<any> {
    return this.http.post<any>(this.baseUrl, {
      params: { category: 'GetUserProfile', EnterpriseID: enterpriseId }
    });
  }

  getRoleDetails(): Observable<any[]> {
    return this.http.post<any[]>(this.baseUrl, { params: { category: 'GetRoleDetails' } });
  }

  getRequestData(requestId: number | string): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}?handler=GetRequestlisting&RequestID=${requestId}`);
  }
  
  getRequests(): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}?handler=GetRequestlisting`);
  }

  insertNewRequest(params: any): Observable<any> {
    return this.http.post(this.baseUrl, { params });
  }

  deleteRequest(requestId: string, modifiedBy: string): Observable<any> {
    return this.http.post(this.baseUrl, {
      params: { category: 'DeleteRequest', RequestID: requestId, IsActive: 0, ModifiedBy: modifiedBy },
    });
  }

  updateRequestList(params: Record<string, any>): Observable<any> {
    return this.http.post(this.baseUrl, { params: { category: 'UpdateRequestList', ...params } });
  }

  getRoleNames(): Observable<any[]> {
    return this.http.get<any[]>(`${this.baseUrl}?handler=GetRoleName`);
  }

  insertUser(params: Record<string, any>): Observable<any> {
    return this.http.post(this.baseUrl, { params: { category: 'InsertUser', ...params } });
  }

  getReviewID(): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}?handler=GetReviewNameList`);
  } 

  insertNewUser(params: any):Observable<any> {
     return this.http.post(this.baseUrl, { params });
  }

  getUserActionItems(enterpriseId: string): Observable<any> {
    return this.http.post<any>(this.baseUrl, {
      params: { category: 'GetUserActionItems', UserID: enterpriseId },
    });
  }

  closeActionItem(reqId: number, updatedBy: string): Observable<any> {
    return this.http.post<any>(this.baseUrl, {
      params: { category: 'ASTUserActionitemClose', ReqId: reqId, IsActive: 0, UpdatedBy: updatedBy },
    });
  }

  getRegionCountryCity(): Observable<any> {
    return this.http.post<any>(this.baseUrl, { params: { category: 'GetRegionCountryCity' } });
  }

  getReviewDashboardCounts(params: {
    PropsedYearId?: string | null;
    Quarter?: string | null;
    ProposedMonth?: string | null;
    ClientName?: string | null;
    DeliveryCountry?: string | null;
    LocationToBeReviewed?: string | null;
    TeamMembers?: string | null;
    Region?: string | null;
    ReviewTypeID?: string | null;
  }): Observable<any> {
    return this.http.post<any>(this.baseUrl, {
      params: { category: 'GetReviewDashboardCounts', ...params },
    });
  }

  getApplicationLogs(params: AuditLogRequestParams): Observable<ApplicationLogResponse[]> {
    return this.http.post<ApplicationLogResponse[]>(this.baseUrl, {
      params: { category: 'GetApplicationLogs', ...params },
    });
  }

  getAuditLogModuleAndActionTypes(): Observable<AuditLogFilterOption[]> {
    return this.http.get<AuditLogFilterOption[]>(
      `${this.baseUrl}?handler=GetAuditLogModuleandActionType`,
    );
  }

  getApplicationLogFields(applicationLogId: number): Observable<ApplicationLogFieldResponse[]> {
    return this.http.post<ApplicationLogFieldResponse[]>(this.baseUrl, {
      params: { category: 'GetApplicationLogFields', ApplicationLogID: applicationLogId },
    });
  }

}

